import BaseProxy from './Proxy';

export default class I18nProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/i18n', parameters);
  }
}
